<!-- Start Currency Transfer Provider Banner Area -->
<div class="ctp-banner-area jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-12">
                <div class="ctp-banner-content">
                    <h1>International Currency <span>Transfer</span> Provider</h1>
                    <ul class="ctp-list">
                        <li> 
                            <img src="assets/img/currency-transfer-provider/banner/circle-check.svg" alt="image"> 
                            Great exchange rates
                        </li>
                        <li>
                            <img src="assets/img/currency-transfer-provider/banner/circle-check.svg" alt="image"> 
                            No hidden fees
                        </li>
                        <li>
                            <img src="assets/img/currency-transfer-provider/banner/circle-check.svg" alt="image"> 
                            24/7 Transfers
                        </li>
                        <li>
                            <img src="assets/img/currency-transfer-provider/banner/circle-check.svg" alt="image"> 
                            5-star customer rating
                        </li>
                        <li>
                            <img src="assets/img/currency-transfer-provider/banner/circle-check.svg" alt="image"> 
                            Award-winning service
                        </li>
                    </ul>
                    <div class="video-view">
                        <a href="https://www.youtube.com/watch?v=bk7McNUjWgw" class="video-btn popup-youtube">
                            <i class="fas fa-play"></i> 
                            <span>See how it works</span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-5 col-md-12">
                <form class="ctp-banner-form">
                    <div class="form-header">
                        <span>Exchange Rate</span>
                        <h3>1 GBP = 1.29356 USD</h3>
                    </div>
                    <div class="form-content">
                        <div class="form-group">
                            <label>Delivery Method</label>
                            <select>
                                <option>Bank Transfer</option>
                                <option>Send Money</option>
                                <option>Interest Money</option>
                                <option>Invest Money</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>You Transfer</label>
                            <input type="text" class="form-control" autocomplete="off" value="100">
                            <div class="amount-currency-select">
                                <select>
                                    <option>GBP</option>
                                    <option>USD</option>
                                    <option>EUR</option>
                                    <option>BRL</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group zero">
                            <label>Recipient Gets</label>
                            <input type="text" class="form-control" autocomplete="off" value="129.35">
                            <div class="amount-currency-select">
                                <select>
                                    <option>USD</option>
                                    <option>GBP</option>
                                    <option>EUR</option>
                                    <option>BRL</option>
                                </select>
                            </div>
                        </div>
                        <div class="info">
                            <p><span>Delivery Time:</span> 1 Working Days</p>
                        </div>
                        <button type="submit" class="btn btn-primary">Send Now</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- End Currency Transfer Provider Banner Area -->

<div class="currency-transfer-provider-with-background-color">

    <!-- Start Countries Area -->
    <div class="ctp-countries-area pt-100 pb-75">
        <div class="container">
            <div class="section-title ctp-title">
                <h2>Popular Countries Our Customers Send Money</h2>
            </div>

            <div class="row justify-content-center">
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img1.png" alt="image">
                        <span>USA</span>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img2.png" alt="image">
                        <span>UK</span>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img3.png" alt="image">
                        <span>New Zealand</span>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img4.png" alt="image">
                        <span>France</span>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img5.png" alt="image">
                        <span>Germany</span>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img6.png" alt="image">
                        <span>Italy</span>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img7.png" alt="image">
                        <span>Greece</span>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img8.png" alt="image">
                        <span>China</span>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img9.png" alt="image">
                        <span>Kuwait</span>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img10.png" alt="image">
                        <span>Argentina</span>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img11.png" alt="image">
                        <span>Sweden</span>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-md-4">
                    <div class="ctp-countries-card">
                        <img src="assets/img/currency-transfer-provider/countries/img12.png" alt="image">
                        <span>Thailand</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Countries Area -->

    <!-- Start Money Transfer Area -->
    <div class="ctp-money-transfer-area pb-75">
        <div class="container">
            <div class="section-title ctp-title">
                <h2>How Does Money Transfer Work?</h2>
            </div>
            
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6">
                    <div class="ctp-money-transfer-card">
                        <h3>Create a free account</h3>
                        <div class="image">
                            <img src="assets/img/currency-transfer-provider/money-transfer/customer.png" alt="image">
                            <div class="number">01</div>
                        </div>
                        <p>Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. vivamus suscipit tortor eget felis porttitor volutpat. Sed porttitor lectus nibh.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="ctp-money-transfer-card">
                        <h3>Send your funds</h3>
                        <div class="image">
                            <img src="assets/img/currency-transfer-provider/money-transfer/profits.png" alt="image">
                            <div class="number">02</div>
                        </div>
                        <p>Vivamus suscipit tortor eget felis porttitor volutpat. sed porttitor lectus nibh. Donec rutrum congue leo eget malesuada.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="ctp-money-transfer-card">
                        <h3>Track your transfer</h3>
                        <div class="image">
                            <img src="assets/img/currency-transfer-provider/money-transfer/data.png" alt="image">
                            <div class="number">03</div>
                        </div>
                        <p>Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. vivamus suscipit tortor eget felis porttitor volutpat.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Money Transfer Area -->

    <!-- Start Choose Area -->
    <div class="ctp-choose-area pb-100">
        <div class="container-fluid">
            <div class="row justify-content-center m-0">
                <div class="col-lg-6 col-md-12 p-0">
                    <div class="ctp-choose-image jarallax" data-jarallax='{"speed": 0.3}'></div>
                </div>

                <div class="col-lg-6 col-md-12 p-0">
                    <div class="ctp-choose-content">
                        <h3>Why Choose Klob</h3>
                        <p>Nulla quis lorem ut libero malesuada feugiat. curabitur non nulla sit amet nisl tempus convallis quis ac lectus. nulla porttitor accumsan tincidunt. lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>

                        <div class="choose-inner-card">
                            <h4>
                                <div class="icon">
                                    <i class="fa-solid fa-check"></i>
                                </div>
                                Bank beating rates
                            </h4>
                            <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. donec rutrum congue leo eget malesuada.</p>
                        </div>
                        <div class="choose-inner-card">
                            <h4>
                                <div class="icon">
                                    <i class="fa-solid fa-check"></i>
                                </div>
                                We're Fast
                            </h4>
                            <p>Nulla porttitor accumsan tincidunt. quisque velit nisi, pretium ut lacinia in, elementum id enim. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi sed porttitor lectus nibh.</p>
                        </div>
                        <div class="choose-inner-card">
                            <h4>
                                <div class="icon">
                                    <i class="fa-solid fa-check"></i>
                                </div>
                                Easy to use
                            </h4>
                            <p>Cras ultricies ligula sed magna dictum porta. donec rutrum congue leo eget malesuada. curabitur aliquet quam id dui posuere blandit. vivamus suscipit tortor eget felis porttitor volutpat. donec sollicitudin molestie malesuada.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Choose Area -->

    <!-- Start Services Area -->
    <div class="ctp-services-area pb-75">
        <div class="container">
            <div class="section-title ctp-title">
                <h2>Personal Currency Transfers Services</h2>
            </div>

            <div class="row justify-content-center">
                <div class="col-lg-3 col-sm-6">
                    <div class="ctp-services-card">
                        <h3>
                            <div class="icon">
                                <img src="assets/img/currency-transfer-provider/services/mobile-payment.svg" alt="image">
                            </div>
                            Regular Payments
                        </h3>
                        <p>Mauris blandit aliquet elit, eget tincidunt nibh pulvinar. quisque velit nisi, pretium ut lacinia in, elementum id enim. proin eget tortor risus. proin eget tortor risus.</p>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6">
                    <div class="ctp-services-card">
                        <h3>
                            <div class="icon">
                                <img src="assets/img/currency-transfer-provider/services/warning.svg" alt="image">
                            </div>
                            Rate Alerts
                        </h3>
                        <p>Mauris blandit aliquet elit, eget tincidunt nibh pulvinar. quisque velit nisi, pretium ut lacinia in, elementum id enim. proin eget tortor risus. proin eget tortor risus.</p>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6">
                    <div class="ctp-services-card">
                        <h3>
                            <div class="icon">
                                <img src="assets/img/currency-transfer-provider/services/fluctuation.svg" alt="image">
                            </div>
                            Market Analysis
                        </h3>
                        <p>Mauris blandit aliquet elit, eget tincidunt nibh pulvinar. quisque velit nisi, pretium ut lacinia in, elementum id enim. proin eget tortor risus. proin eget tortor risus.</p>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6">
                    <div class="ctp-services-card">
                        <h3>
                            <div class="icon">
                                <img src="assets/img/currency-transfer-provider/services/contract.svg" alt="image">
                            </div>
                            Spot Contracts
                        </h3>
                        <p>Mauris blandit aliquet elit, eget tincidunt nibh pulvinar. quisque velit nisi, pretium ut lacinia in, elementum id enim. proin eget tortor risus. proin eget tortor risus.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Services Area -->

    <!-- Start Key Features Area -->
    <div class="ctp-key-features-area ptb-100">
        <div class="container">
            <div class="section-title ctp-title">
                <h2>Money Transfer Company Key Features</h2>
            </div>

            <div class="ctp-key-features-tabs">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="security-tab" data-bs-toggle="tab" href="#security" role="tab" aria-controls="security">Security</a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" id="cost-tab" data-bs-toggle="tab" href="#cost" role="tab" aria-controls="cost">Cost</a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" id="speed-tab" data-bs-toggle="tab" href="#speed" role="tab" aria-controls="speed">Speed</a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" id="accessibility-tab" data-bs-toggle="tab" href="#accessibility" role="tab" aria-controls="accessibility">Accessibility</a>
                    </li>
                </ul>

                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="security" role="tabpanel">
                        <div class="row justify-content-center">
                            <div class="col-lg-5 col-md-12">
                                <div class="ctp-key-features-image"></div>
                            </div>
                            <div class="col-lg-7 col-md-12">
                                <div class="ctp-key-features-content">
                                    <p>Quisque velit nisi, pretium ut lacinia in, elementum id enim. vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. pretium ut lacinia in, elementum id enim.</p>
                                    <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. pellentesque in ipsum id orci porta dapibus. curabitur non nulla sit amet nisl tempus convallis quis ac lectus. quisque velit nisi elementum id enim.</p>
                                    <ul class="list">
                                        <li><i class="fa-solid fa-check"></i> Quisque velit nisi, pretium ut lacinia in, elementum id enim.</li>
                                        <li><i class="fa-solid fa-check"></i> Vestibulum ac diam sit amet quam vehicula elementum sed sit amet.</li>
                                        <li><i class="fa-solid fa-check"></i> Donec rutrum congue leo eget malesuada.</li>
                                        <li><i class="fa-solid fa-check"></i> Curabitur non nulla sit amet nisl tempus convallis quis ac lectus.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="cost" role="tabpanel">
                        <div class="row justify-content-center">
                            <div class="col-lg-5 col-md-12">
                                <div class="ctp-key-features-image"></div>
                            </div>
                            <div class="col-lg-7 col-md-12">
                                <div class="ctp-key-features-content">
                                    <p>Quisque velit nisi, pretium ut lacinia in, elementum id enim. vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. pretium ut lacinia in, elementum id enim.</p>
                                    <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. pellentesque in ipsum id orci porta dapibus. curabitur non nulla sit amet nisl tempus convallis quis ac lectus. quisque velit nisi elementum id enim.</p>
                                    <ul class="list">
                                        <li><i class="fa-solid fa-check"></i> Quisque velit nisi, pretium ut lacinia in, elementum id enim.</li>
                                        <li><i class="fa-solid fa-check"></i> Vestibulum ac diam sit amet quam vehicula elementum sed sit amet.</li>
                                        <li><i class="fa-solid fa-check"></i> Donec rutrum congue leo eget malesuada.</li>
                                        <li><i class="fa-solid fa-check"></i> Curabitur non nulla sit amet nisl tempus convallis quis ac lectus.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="speed" role="tabpanel">
                        <div class="row justify-content-center">
                            <div class="col-lg-5 col-md-12">
                                <div class="ctp-key-features-image"></div>
                            </div>
                            <div class="col-lg-7 col-md-12">
                                <div class="ctp-key-features-content">
                                    <p>Quisque velit nisi, pretium ut lacinia in, elementum id enim. vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. pretium ut lacinia in, elementum id enim.</p>
                                    <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. pellentesque in ipsum id orci porta dapibus. curabitur non nulla sit amet nisl tempus convallis quis ac lectus. quisque velit nisi elementum id enim.</p>
                                    <ul class="list">
                                        <li><i class="fa-solid fa-check"></i> Quisque velit nisi, pretium ut lacinia in, elementum id enim.</li>
                                        <li><i class="fa-solid fa-check"></i> Vestibulum ac diam sit amet quam vehicula elementum sed sit amet.</li>
                                        <li><i class="fa-solid fa-check"></i> Donec rutrum congue leo eget malesuada.</li>
                                        <li><i class="fa-solid fa-check"></i> Curabitur non nulla sit amet nisl tempus convallis quis ac lectus.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="accessibility" role="tabpanel">
                        <div class="row justify-content-center">
                            <div class="col-lg-5 col-md-12">
                                <div class="ctp-key-features-image"></div>
                            </div>
                            <div class="col-lg-7 col-md-12">
                                <div class="ctp-key-features-content">
                                    <p>Quisque velit nisi, pretium ut lacinia in, elementum id enim. vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. pretium ut lacinia in, elementum id enim.</p>
                                    <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. pellentesque in ipsum id orci porta dapibus. curabitur non nulla sit amet nisl tempus convallis quis ac lectus. quisque velit nisi elementum id enim.</p>
                                    <ul class="list">
                                        <li><i class="fa-solid fa-check"></i> Quisque velit nisi, pretium ut lacinia in, elementum id enim.</li>
                                        <li><i class="fa-solid fa-check"></i> Vestibulum ac diam sit amet quam vehicula elementum sed sit amet.</li>
                                        <li><i class="fa-solid fa-check"></i> Donec rutrum congue leo eget malesuada.</li>
                                        <li><i class="fa-solid fa-check"></i> Curabitur non nulla sit amet nisl tempus convallis quis ac lectus.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>    
        </div>
    </div>
    <!-- End Key Features Area -->

    <!-- Start Working People Area -->
    <div class="ctp-working-people-area ptb-100">
        <div class="container-fluid">
            <div class="row justify-content-center m-0">
                <div class="col-lg-6 col-md-12 p-0">
                    <div class="ctp-working-people-content">
                        <h3>Being A Money Transfer Service For Hard Working People</h3>

                        <div class="working-people-inner-card">
                            <div class="icon">
                                <img src="assets/img/currency-transfer-provider/working-people/save-time.svg" alt="image">
                            </div>
                            <h4>Save time</h4>
                            <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. donec rutrum congue leo eget malesuada.</p>
                        </div>

                        <div class="working-people-inner-card">
                            <div class="icon">
                                <img src="assets/img/currency-transfer-provider/working-people/money-saving.svg" alt="image">
                            </div>
                            <h4>Save money</h4>
                            <p>Nulla porttitor accumsan tincidunt. quisque velit nisi, pretium ut lacinia in, elementum id enim. praesent sapien massa, convallis a pellentesque nec, egestas non nisi. sed porttitor lectus nibh.</p>
                        </div>

                        <div class="working-people-inner-card">
                            <div class="icon">
                                <img src="assets/img/currency-transfer-provider/working-people/secure.svg" alt="image">
                            </div>
                            <h4>Send securely</h4>
                            <p>Cras ultricies ligula sed magna dictum porta. donec rutrum congue leo eget malesuada. curabitur aliquet quam id dui posuere blandit. vivamus suscipit tortor eget felis porttitor volutpat.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12 p-0">
                    <div class="ctp-working-people-image jarallax" data-jarallax='{"speed": 0.3}'></div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Working People Area -->

    <!-- Start Protec Area -->
    <div class="ctp-protec-area pb-75">
        <div class="container">
            <div class="section-title ctp-title">
                <h2>Protecting Your Money</h2>
            </div>

            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-6">
                    <div class="ctp-protec-card">
                        <div class="content">
                            <div class="number">
                                <span>01</span>
                            </div>
                            <h3>Safeguarded with leading banks</h3>
                            <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="ctp-protec-card">
                        <div class="content">
                            <div class="number color-two">
                                <span>02</span>
                            </div>
                            <h3>Extra-secure transactions</h3>
                            <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="ctp-protec-card">
                        <div class="content">
                            <div class="number color-two">
                                <span>03</span>
                            </div>
                            <h3>Audited regularly</h3>
                            <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="ctp-protec-card">
                        <div class="content">
                            <div class="number">
                                <span>04</span>
                            </div>
                            <h3>Data protection</h3>
                            <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Protec Area -->

    <!-- Start App Area -->
    <div class="ctp-app-area">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="ctp-app-content">
                        <span class="sub">Download App</span>
                        <h3>Let’s get your free copy from apple and play store</h3>
                        <p>Instant free download from store cloud based storage for your data backup just log in with your mail account from play store and using whatever you want for your business purpose.</p>
                        <div class="btn-box">
                            <a href="#" class="app-store-btn" target="_blank">
                                <i class="flaticon-apple"></i>
                                Download on
                                <span>App Store</span>
                            </a>

                            <a href="#" class="play-store-btn" target="_blank">
                                <i class="flaticon-play-store"></i>
                                Download on
                                <span>Google play</span>
                            </a>
                        </div>
                        <div class="info">
                            <span>Over 10 million downloads worldwide</span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="ctp-app-image">
                        <img src="assets/img/currency-transfer-provider/app/app.png" alt="image">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End App Area -->
    
    <!-- Start Reviews Area -->
    <div class="ctp-reviews-area pt-100 pb-75">
        <div class="container">
            <div class="section-title ctp-title">
                <h2>Ratings And Reviews</h2>
            </div>

            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6">
                    <div class="ctp-reviews-box">
                        <ul class="rating">
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <span>Reviews 15</span>
                            </li>
                        </ul>
                        <h3>Great exchange rates</h3>
                        <p>
                            Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Donec rutrum leo eget malesuada.
                        </p>
                        <h4>Alisha Ingram <span>(CEO & Founder)</span></h4>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="ctp-reviews-box">
                        <ul class="rating">
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <span>Reviews 10</span>
                            </li>
                        </ul>
                        <h3>Safe and secure</h3>
                        <p>
                            Proin eget tortor risus. Cras ultricies ligula sed magna dictum porta. lorem ipsum dolor sit amet, consectetur adipiscing elit. mauris blandit aliquet elit.
                        </p>
                        <h4>Sharon Bass <span>(Manager)</span></h4>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="ctp-reviews-box">
                        <ul class="rating">
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <img src="assets/img/currency-transfer-provider/star.svg" alt="image">
                            </li>
                            <li>
                                <span>Reviews 16</span>
                            </li>
                        </ul>
                        <h3>Award-winning service</h3>
                        <p>
                            Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. praesent sapien massa, convallis a pellentesque nec, egestas non nisi. proin eget tortor risus.
                        </p>
                        <h4>Nancy Artiaga <span>(Founder at Klob)</span></h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Reviews Area -->

    <!-- Start FAQ Area -->
    <div class="ctp-faq-area pb-100">
        <div class="container">
            <div class="section-title ctp-title">
                <h2>Frequently Asked Questions</h2>
            </div>
            
            <div class="ctp-faq-accordion">
                <div class="accordion" id="FaqAccordion">
                    <div class="accordion-item">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            How do I create an account with Klob?
                        </button>
                        <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#FaqAccordion">
                            <div class="accordion-body">
                                <p>Quisque velit nisi, pretium ut lacinia in, elementum id enim. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                                <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. pellentesque in ipsum id orci porta dapibus. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                            </div>
                        </div>
                    </div>

                    <div class="accordion-item">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            How to send money online?
                        </button>
                        <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#FaqAccordion">
                            <div class="accordion-body">
                                <p>Quisque velit nisi, pretium ut lacinia in, elementum id enim. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                                <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. pellentesque in ipsum id orci porta dapibus. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                            </div>
                        </div>
                    </div>

                    <div class="accordion-item">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            Is my money safe with Klob?
                        </button>
                        <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#FaqAccordion">
                            <div class="accordion-body">
                                <p>Quisque velit nisi, pretium ut lacinia in, elementum id enim. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                                <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. pellentesque in ipsum id orci porta dapibus. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                            </div>
                        </div>
                    </div>

                    <div class="accordion-item">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            What verification do I need to send money? 
                        </button>
                        <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#FaqAccordion">
                            <div class="accordion-body">
                                <p>Quisque velit nisi, pretium ut lacinia in, elementum id enim. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                                <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. pellentesque in ipsum id orci porta dapibus. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                            </div>
                        </div>
                    </div>

                    <div class="accordion-item">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                            How does Klob protect your money?
                        </button>
                        <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#FaqAccordion">
                            <div class="accordion-body">
                                <p>Quisque velit nisi, pretium ut lacinia in, elementum id enim. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                                <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. pellentesque in ipsum id orci porta dapibus. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End FAQ Area -->

</div>